module.exports = __webpack_public_path__ + "static/img/top.accd76e.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/top.png
// module id = gMT2
// module chunks = 1